/*
Copyright (C) 2020 Broadleaf Commerce.

Licensed under the Broadleaf End User License Agreement (EULA),
Version 1.1 (the “Commercial License” located at
http://license.broadleafcommerce.org/commercial_license-1.1.txt).

Alternatively, the Commercial License may be replaced with a mutually
agreed upon license (the “Custom License”) between you and
Broadleaf Commerce. You may not use this file except in compliance
with the applicable license.
*/

import { getCustomerEndpoint } from '@src/oms/InvoicesView/utils/InvoicesOperationUtils';
import { useCallback, useState } from 'react';
import { request } from '@broadleaf/admin-components/dist/metadata/utils/request';
import { ICustomer } from '@src/oms/utils/RmCustomerUtils';

type Response = {
  fetchCustomer: (customerId: string, contextParams: any) => Promise<ICustomer>;
  isLoading: boolean;
};

export default function useFetchCustomer(): Response {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const fetchCustomer = useCallback(
    async (customerId, contextParams) => {
      if (isLoading) {
        return;
      }

      setIsLoading(true);
      try {
        const endpoint = getCustomerEndpoint(customerId);
        const { data } = await request({ ...endpoint }, contextParams);
        return data;
      } finally {
        setIsLoading(false);
      }
    },
    [isLoading]
  );

  return { fetchCustomer, isLoading };
}
